import {
  collection,
  getDocs,
  getFirestore,
  orderBy,
  query,
} from "firebase/firestore";
import { store } from "@/store";
import { InboxStore } from "@/store/constants";
import { ICustomField } from "@/types/inbox/fields";

/**
 * Gets all custom fields
 */
export const getAllFields = async (): Promise<ICustomField[]> => {
  const chatbotId = store.getters[InboxStore.Getters.GET_CHATBOT_ID];
  const docs = await getDocs(
    query(
      collection(
        getFirestore(),
        "dialogs/" + chatbotId + "/settings/inbox/fields"
      ),
      orderBy("name", "asc")
    )
  );
  return docs.docs.map((doc) => {
    return {
      id: doc.id,
      ...doc.data(),
    } as ICustomField;
  });
};
